import styled from "@emotion/styled";
import { observer } from "mobx-react-lite";
import type React from "react";
import { Suspense, lazy } from "react";

import { FavoriteMarkets } from "@components/FavoriteMarkets";
import { MarketData } from "@components/MarketData";
import { OrderbookAndTrades } from "@components/OrderbookAndTrades";
import { Tradebox } from "@components/Tradebox";
import { theme } from "@themes/themes";

import { TradingViewChart } from "./TradingView";

const TradeTables = lazy(() => import("./TradeTables/TradeTables").then((m) => ({ default: m.TradeTables })));

export const HomeDesktopLayout: React.FC = observer(() => (
  <LayoutContainer>
    <ExchangeHeader>
      <FavoriteMarkets />
      <MarketData />
    </ExchangeHeader>

    <TradingWrapper>
      <TradingViewChart />
    </TradingWrapper>

    <TradeTablesWrapper>
      <Suspense fallback={<TradeTablesFallback data-testid="trade-tables:fallback" />}>
        <TradeTables />
      </Suspense>
    </TradeTablesWrapper>

    <OrderbookWrapper>
      <OrderbookAndTrades />
    </OrderbookWrapper>

    <TradeboxWrapper>
      <Tradebox />
    </TradeboxWrapper>
  </LayoutContainer>
));

const LayoutContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 300px 300px;
  grid-template-rows: auto minmax(600px, 1fr) 300px;
  gap: 4px;

  height: 100%;
  min-height: 0;
  overflow: hidden;
`;

const ExchangeHeader = styled.div`
  grid-column: 1 / 4;
  grid-row: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const TradingWrapper = styled.div`
  grid-column: 1;
  grid-row: 2;
  height: 100%;
  min-height: 0;
`;

const TradeTablesWrapper = styled.div`
  grid-column: 1;
  grid-row: 3;
  overflow: auto;
  min-height: 0;
  height: 100%;
`;

const TradeTablesFallback = styled.div`
  background: ${theme.color("gray-2")};
  min-height: 300px;
  height: 100%;
  border: 1px solid ${theme.color("gray-6")};
  border-radius: 8px;
`;

const OrderbookWrapper = styled.div`
  grid-column: 2;
  grid-row: 2 / 4;
  overflow: auto;
  min-height: 0;
  height: 100%;
`;

const TradeboxWrapper = styled.div`
  grid-column: 3;
  grid-row: 2 / 4;
  overflow: auto;
  min-height: 0;
`;
